const CACHE_SCHEMA_KEY = 'astro_cache_schema_version';
const CACHE_SCHEMA_VERSION = '2026-05-07-web-cache-v1';

// Nunca limpar autenticação/sessão do usuário.
const PRESERVED_KEYS = new Set([
  'astro_auth_token',
  'astro_user_data'
]);

const EXACT_KEYS_TO_CLEAR = new Set([
  'astro_contatos',
  'connections',
  'active_connections',
  'legacy_company_settings',
  'legacy_user_profile'
]);

const PREFIXES_TO_CLEAR = [
  'conversations_',
  'messages_',
  'atendimentos_conn_order_',
  'astro_profile_',
  'astro_profile_geo_',
  'astro_company_settings_'
];

function shouldClearKey(key) {
  if (!key) return false;
  if (PRESERVED_KEYS.has(key)) return false;
  if (EXACT_KEYS_TO_CLEAR.has(key)) return true;
  return PREFIXES_TO_CLEAR.some((prefix) => key.startsWith(prefix));
}

export function runCacheSchemaMigration() {
  try {
    const current = localStorage.getItem(CACHE_SCHEMA_KEY);
    if (current === CACHE_SCHEMA_VERSION) return;

    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }

    keys.forEach((key) => {
      if (shouldClearKey(key)) {
        localStorage.removeItem(key);
      }
    });

    localStorage.setItem(CACHE_SCHEMA_KEY, CACHE_SCHEMA_VERSION);
  } catch (_) {
    // Sem throw para não interromper boot da aplicação.
  }
}

